// src/components/Navbar.jsx
import React, { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, NavLink } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <nav className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
          <img
            src="/logo.png"
            alt="FutureYX Logo"
            className="inline-block mr-2 w-[250px] sm:hidden"
          />
          <img
            src="/logo.png"
            alt="FutureYX Logo"
            className="hidden sm:inline-block mr-2 w-[250px]"
          />

        {/* Desktop Links */}
        <div className="hidden md:flex space-x-8">
          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `text-lg font-medium ${
                  isActive ? "text-[#D7631F]" : "text-gray-700 hover:text-[#D7631F]"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-gray-700"
          aria-label="Toggle menu"
        >
          {open ? <XMarkIcon className="w-7 h-7" /> : <Bars3Icon className="w-7 h-7" />}
        </button>
      </div>

      {/* Mobile Slide-in Menu */}
      <div
        className={`md:hidden fixed inset-y-0 left-0 w-3/4 max-w-xs bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
          open ? "translate-x-0" : "-translate-x-full"
        }`} style={{ zIndex: 1000 }}
      >
        <div className="px-6 py-8">
          <button
            onClick={() => setOpen(false)}
            className="mb-8 text-gray-700"
            aria-label="Close menu"
          >
            <XMarkIcon className="w-8 h-8" />
          </button>
          <nav className="flex flex-col space-y-6">
            {links.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-xl ${
                    isActive ? "text-[#D7631F]" : "text-gray-700 hover:text-[#D7631F]"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </nav>
  );
}
